var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Flex, FormLabel, useRadio, useRadioGroup, } from '@chakra-ui/react';
import React from 'react';
import { useController } from 'react-hook-form';
var RadioButton = function (_a) {
    var styles = _a.styles, props = __rest(_a, ["styles"]);
    var _b = useRadio(props), getInputProps = _b.getInputProps, getRadioProps = _b.getRadioProps;
    var input = getInputProps();
    var checkbox = getRadioProps();
    return (React.createElement(Flex, { alignItems: 'center', as: 'label', flexGrow: '1' },
        React.createElement("input", __assign({}, input)),
        React.createElement(Flex, __assign({ as: 'span' }, checkbox, { _checked: {
                fontWeight: 'semibold',
                borderColor: 'primary.pure',
            }, alignItems: 'center', bg: 'bg.pure', borderRadius: 'md', borderWidth: '1px', cursor: 'pointer', flexGrow: '1', justifyContent: 'center', minH: 10, textTransform: 'capitalize' }, styles), props.children)));
};
var RadioButtonField = function (_a) {
    var options = _a.options, name = _a.name, label = _a.label, containerStyles = _a.containerStyles, props = __rest(_a, ["options", "name", "label", "containerStyles"]);
    var _b = useController({
        name: name,
    }).field, onChange = _b.onChange, value = _b.value;
    var _c = useRadioGroup({
        name: name,
        defaultValue: value,
    }), getRootProps = _c.getRootProps, getRadioProps = _c.getRadioProps;
    var group = getRootProps();
    return (React.createElement(Flex, __assign({}, group, { flexDir: 'column', onChange: onChange }),
        label && React.createElement(FormLabel, { htmlFor: name }, label),
        React.createElement(Flex, __assign({ gap: 'sm', justifyContent: 'space-between' }, containerStyles), options.map(function (_a) {
            var label = _a.label, value = _a.value;
            var radio = getRadioProps({ value: value });
            return (React.createElement(RadioButton, __assign({ key: value, styles: props }, radio), label));
        }))));
};
export default RadioButtonField;
//# sourceMappingURL=RadioButtonField.js.map